import { Navbar, Text } from '@lego/klik-ui';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import styles from '../main-navbar.module.css';

export const MenuItem = forwardRef<
  HTMLAnchorElement,
  {
    isActive: boolean;
    isPressed?: boolean;
    onClick?: () => void;
    to?: string;
    children: React.ReactNode;
  }
>(({ isActive, isPressed, onClick, to, children }, ref) => (
  <Navbar.Item
    ref={ref}
    isActive={isActive}
    className={[
      styles.menuItem,
      isActive && styles.menuItemActive,
      isPressed && styles.menuItemPressed,
    ]
      .filter(Boolean)
      .join(' ')}
    onClick={onClick}
    as={to ? Link : undefined}
    to={to}
  >
    <Text fontSize="md" fontWeight="normal" lineHeight="150%">
      {children}
    </Text>
  </Navbar.Item>
));
